import { useEffect, useState } from "react";
import "../assets/styles/views/documents.scss";
import { useLocation, useOutletContext } from "react-router-dom";
import {
  districts_list,
  get_hierarchy_info,
  get_document_list,
  rcr_area,
  get_user_pv,
} from "../utils/endpoints";
import DocumentCard from "../components/DocumentCard";
import UploadDocument from "../components/modal-contents/UploadDocument";
import CloseRounded from "../assets/icons/close-rounded";
import Download from "../assets/icons/download";
import BackArrowButton from "../components/BackArrowButton";

export default function Documents() {
  const [context, setContext] = useOutletContext();
  const [districts, setDistricts] = useState();
  const [selected_district, setSelectedDistrict] = useState();
  const [cavr, setCavr] = useState();
  const [selected_cavr, setSelectedCavr] = useState();
  const [rcr, setRcr] = useState();
  const [selected_rcr, setSelectedRcr] = useState();
  const [selected_manager, setSelectedManager] = useState();
  const [selected_file, setSelectedFile] = useState();
  const [document_list, setDocumentList] = useState();
  const [initial_load, setInitialLoad] = useState(true);
  const [role, setRole] = useState();
  const [image_view, setImageView] = useState();

  const location = useLocation();

  const openFile = (attachment, file_url) => {
    setImageView(
      <div className="image-viewer w-100 h-100 position-fixed top-0 start-0 d-flex justify-content-center align-items-center">
        <div className="d-flex align-items-center position-absolute end-0 top-0 mt-2 me-2">
          <Download
            className="me-4"
            onClick={() => downloadImage(attachment, file_url)}
            size={25}
            color="#ffffff"
          />
          <CloseRounded
            onClick={() => setImageView()}
            size={30}
            color="#ffffff"
          />
        </div>

        <img src={file_url} className="w-100" />
      </div>
    );
  };

  const downloadImage = async (attachment, file_url) => {
    const response = await fetch(file_url);
    const blobImage = await response.blob();
    const href = URL.createObjectURL(blobImage);
    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = attachment.name;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  };

  const getHierarchy = async (id) => {
    const response = await context.httpRequest(
      "get",
      rcr_area.replace("*", id),
      null,
      context.session.token
    );
    return response;
  };

  const loadDistricts = async () => {
    let response = await context.httpRequest(
      "get",
      districts_list,
      null,
      context.session.token
    );
    if (response.result) {
      if (location.state && initial_load) {
        let last_district_selected = response.data.find(
          (x) => x.codice === location.state.doc.codiceDistrict
        ).id;
        setSelectedDistrict(last_district_selected);
      }
      return response.data;
    }
    return response;
  };

  const loadUserHierarchyInfo = async () => {
    let response = await context.httpRequest(
      "get",
      get_hierarchy_info,
      null,
      context.session.token
    );
    if (response.result) {
      return response.data;
    }
    return response;
  };

  const loadAttachmentList = async () => {
    if (selected_manager) {
      let pv_associated = selected_manager.listaPv.split(",");

      let promises = [];
      pv_associated.map((item, index) => {
        let promise = Promise.resolve(
          context.httpRequest(
            "get",
            `${get_document_list}?pvCode=${selected_rcr}`,
            null,
            context.session.token
          )
        );
        promises.push(promise);
      });
      setContext({ loader: true });
      Promise.all(promises).then((values) => {
        let docs = [];
        if (values) {
          values.map((item, index) => {
            if (item.result) docs = [...docs, ...item.data];
          });
        }

        let response_groups = Object.groupBy(
          docs,
          ({ attachment }) => attachment.id
        );
        setDocumentList(response_groups);
      });
      setContext({ loader: false });
    } else {
      if (selected_rcr) {
        setContext({ loader: true });
        const response = await context.httpRequest(
          "get",
          `${get_document_list}?idHierarchy=${selected_rcr}`,
          null,
          context.session.token
        );
        if (response.result) {
          let response_groups = Object.groupBy(
            response.data,
            ({ attachment }) => attachment.id
          );
          setDocumentList(response_groups);
        }
        setContext({ loader: false });
      }
    }
  };

  useEffect(() => {
    if (role) {
      (async () => {
        if (role == "ADMIN") {
          let districts = await loadDistricts();
          if (districts) {
            setDistricts(districts);
          }
        } else {
          if (role !== "GESTORE") {
            const hierarchy_info = await loadUserHierarchyInfo();
            switch (role) {
              case "DM":
                setSelectedDistrict(hierarchy_info.id);
                break;
              case "AM":
                setSelectedCavr(hierarchy_info.id);
                break;
              case "RCR":
                setSelectedRcr(hierarchy_info.id);
                break;
            }
          } else {
            (async () => {
              let response = await context.httpRequest(
                "get",
                `${get_user_pv}?email=${context.session?.email}`,
                null,
                context.session.token
              );
              if (
                response?.result &&
                response?.data &&
                response?.data.length > 0
              )
                setSelectedManager(response.data[0]);
            })();
          }
        }
      })();
    }
  }, [role]);

  useEffect(() => {
    if (!!context.session) {
      setRole(context.session.profileTypeCode);
    }
  }, [context.session]);

  useEffect(() => {
    setCavr();
    setRcr();
    setSelectedCavr("");
    setSelectedRcr("");
    if (selected_district) {
      (async () => {
        const response = await getHierarchy(selected_district);
        if (response.result) {
          setCavr(response.data);
          if (location.state && initial_load) {
            let last_cavr_selected = response.data.find(
              (x) => x.codice === location.state.doc.codiceArea
            ).id;
            setSelectedCavr(last_cavr_selected);
          }
        }
      })();
    }
  }, [selected_district]);

  useEffect(() => {
    setRcr();
    setSelectedRcr("");
    if (selected_cavr) {
      (async () => {
        const response = await getHierarchy(selected_cavr);
        if (response.result) {
          setRcr(response.data);
          if (location.state && initial_load) {
            let last_rcr_selected = response.data.find(
              (x) => x.codice === location.state.doc.loginRcr
            ).id;
            setSelectedRcr(last_rcr_selected);
            setInitialLoad(false);
          }
        }
      })();
    }
  }, [selected_cavr]);

  useEffect(() => {
    if (selected_rcr) loadAttachmentList();
  }, [selected_rcr]);

  useEffect(() => {
    if (selected_manager) {
      if (selected_manager?.listaPv) {
        loadAttachmentList();
      }
    }
  }, [selected_manager]);

  useEffect(() => {
    if (selected_file) {
      context.openModal(
        <UploadDocument
          selected_file={selected_file}
          selected_rcr={selected_rcr}
          setSelectedFile={setSelectedFile}
          loadAttachmentList={loadAttachmentList}
          context={context}
        />,
        false
      );
    } else {
      const file_field = document.getElementById("file-field");
      if (file_field) file_field.value = "";
    }
  }, [selected_file]);

  return (
    <>
      <BackArrowButton path="/" />
      <section className="documents w-100 flex-md-wrap px-md-3 d-flex">
        <h1 className="documents__title px-3 mt-3 mt-md-4 mb-3 text-start text-md-center">
          Elenco documenti per punti vendita
        </h1>
        {role && !["RCR", "GESTORE"].includes(role) ? (
          <div className="documents__filters-container position-sticky p-3 mx-3 mx-md-auto border shadow-sm">
            {role === "ADMIN" ? (
              <>
                <label>DISTRETTO</label>
                <select
                  name="districts"
                  onChange={(e) => setSelectedDistrict(e.target.value)}
                  className="w-100 mb-3"
                  required
                  value={selected_district}
                >
                  <option value="">Seleziona..</option>
                  {districts
                    ? districts.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.nome}
                          </option>
                        );
                      })
                    : null}
                </select>
              </>
            ) : null}
            {["ADMIN", "DM"].includes(role) ? (
              <>
                <label>CAVR</label>
                <select
                  disabled={!!selected_district ? false : true}
                  name="cavr"
                  onChange={(e) => setSelectedCavr(e.target.value)}
                  className="w-100 mb-3"
                  required
                  value={selected_cavr}
                >
                  <option value="">Seleziona..</option>
                  {cavr
                    ? cavr.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.type} {item.nome}
                          </option>
                        );
                      })
                    : null}
                </select>
              </>
            ) : null}

            <label>RCR</label>
            <select
              disabled={!!selected_cavr ? false : true}
              name="rcr"
              onChange={(e) => setSelectedRcr(e.target.value)}
              className="w-100"
              required
              value={selected_rcr}
            >
              <option value="">Seleziona..</option>
              {rcr
                ? rcr.map((item, index) => {
                    return (
                      <option value={item.id} key={index}>
                        {item.rcrCognome} {item.rcrNome}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
        ) : null}

        {role !== "GESTORE" && selected_rcr ? (
          <div className="documents__add-new position-sticky mx-3 mx-md-auto mt-3 px-3 py-2 shadow-sm">
            <input
              id="file-field"
              type="file"
              onChange={(e) => setSelectedFile(e.target.files)}
            />
          </div>
        ) : null}

        {document_list ? (
          Object.values(document_list).length > 0 ? (
            <strong className="documents__search-title d-none d-md-block w-100 text-center mt-3 mt-md-5">
              Seleziona documento
            </strong>
          ) : (
            <span className="documents__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
              Nessun risultato da mostrare
            </span>
          )
        ) : (
          <span className="documents__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
            {!["RCR", "GESTORE"].includes(role)
              ? "Compila tutti i filtri per proseguire"
              : "Nessun risultato da mostrare"}
          </span>
        )}

        <div
          className={`documents__container-list mb-md-5 ${
            !["RCR", "GESTORE"].includes(role) ? "mt-4" : "mt-md-4"
          } d-md-flex flex-md-wrap main-panel w-100 p-3 p-md-0`}
        >
          {document_list ? (
            Object.values(document_list).length > 0 ? (
              <>
                <strong className="d-block d-md-none mb-3">
                  Seleziona documento
                </strong>
                {Object.values(document_list).map((item, index) => {
                  return (
                    <DocumentCard
                      document_info={item}
                      context={context}
                      openFile={openFile}
                      key={index}
                      loadAttachmentList={loadAttachmentList}
                      role={role}
                    />
                  );
                })}
              </>
            ) : (
              <span className="d-block d-md-none w-100 text-center mt-5">
                Nessun risultato da mostrare
              </span>
            )
          ) : (
            <span className="d-block d-md-none w-100 text-center mt-5">
              {!["RCR", "GESTORE"].includes(role)
                ? "Compila tutti i filtri per proseguire"
                : "Nessun risultato da mostrare"}
            </span>
          )}
        </div>
      </section>
      {image_view}
    </>
  );
}
